import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import AnalyticsDashboard from "./AnalyticsDashboard";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Analytics",        id: "analytics" },
];


const AnalyticsPage: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
      <AnalyticsDashboard />
    </Section>
  </ScrollPage>
);

export default AnalyticsPage;